import { isBrowser } from "../logic";
var useMenuPositionProps = function useMenuPositionProps(menuPlacement, menuPosition, portalMenu) {
  return {
    menuPlacement: menuPlacement,
    menuPosition: portalMenu ? "absolute" : menuPosition,
    // if portalMenu is true, set menuPosition to absolute, otherwise use the menuPosition prop or default to absolute
    menuPortalTarget: portalMenu && isBrowser() && document.body // check if portalMenu is true and if the browser is available and if so, set the menuPortalTarget to the document.body
  };
};
export default useMenuPositionProps;